/* This file is autogenerated, see readme.md for instructions */
import WeblayerSvgIcon from '@bloomreach/banana-theme/icons/weblayer.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WeblayerIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WeblayerSvgIcon />
    </Icon>
  );
});

WeblayerIcon.displayName = 'WeblayerIcon';

export default WeblayerIcon;
